import { Component, Input, OnInit } from '@angular/core';

import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { deleteProp, getRandomHexString } from '../../../../../../../../utils';
import { MembershipPerCustomerAddOn } from '../../../../../../../../models/membership';
import { TaxRate } from '../../../../../../../../models/tax-rate';
import { SelectLocationModalComponent } from '../../../../../modals/select-location-modal/select-location-modal.component';
import { CapitanLocation } from '../../../../../../../../models/location';
import { LocationService } from '../../../../../../../../services/location/location.service';

@Component({
  selector: 'app-edit-membership-per-customer-add-on-modal',
  templateUrl: './edit-membership-per-customer-add-on-modal.component.html',
  styleUrls: ['./edit-membership-per-customer-add-on-modal.component.css']
})
export class EditMembershipPerCustomerAddOnModalComponent implements OnInit {
  @Input() inputAddOn: MembershipPerCustomerAddOn = null;
  @Input() isGroupMembership: boolean;
  @Input() taxRateList: TaxRate[];
  @Input() usesSpecificAllthenticateProducts = false;
  @Input() completedCallback: (result: any) => undefined;

  public addOn: MembershipPerCustomerAddOn = {
    id: getRandomHexString(8),
    name: '',
    fee: '',
    is_visible: true,
    icon_color_hex: '',
    icon_initials: '',
    revenue_account_codes: {},
    tax_rate_id: undefined,
    tax_rate_per_location: {},
    sends_allthenticate_invite: false,
    overrides_limited_entry: false,
  };
  public feeNumber: number = null;
  public hasPerLocationTaxRates = false;

  public errors: any = {};
  public errorMessage = '';

  readonly deleteProp = deleteProp;
  readonly Object = Object;

  constructor(
    public activeModal: NgbActiveModal,
    public locationService: LocationService,
    private modalService: NgbModal,
  ) {}

  ngOnInit() {
    // Get a deep copy of the input add-on, if one was provided. This ensures
    // that the add-on is only updated once it is submitted, rather than as the
    // user edits it.
    if (this.inputAddOn !== null) {
      for (const key of Object.keys(this.inputAddOn)) {
        this.addOn[key] = this.inputAddOn[key];
      }
      this.feeNumber = parseFloat(this.addOn.fee);
    }

    if (this.addOn.tax_rate_per_location === undefined) {
      this.addOn.tax_rate_per_location = {};
    }

    // Add-ons saved before PRO-1430 carry neither Allthenticate key, and the
    // copy above only copies the keys the input add-on actually has.
    this.addOn.sends_allthenticate_invite = !!this.addOn.sends_allthenticate_invite;
    this.addOn.overrides_limited_entry = !!this.addOn.overrides_limited_entry;

    if (Object.keys(this.addOn.tax_rate_per_location).length > 0) {
      this.hasPerLocationTaxRates = true;
    }
  }

  public handleSubmit() {
    this.errors = {};
    this.errorMessage = '';

    if (this.addOn.name === '') {
      this.errors.name = 'This field is required.';
    }

    if (this.feeNumber === null) {
      this.errors.feeNumber = 'This field is required.';
    } else if (this.feeNumber < 0) {
      this.errors.feeNumber = 'This value may not be negative.';
    } else {
      this.addOn.fee = this.feeNumber.toString();
    }

    if (this.addOn.icon_color_hex.length !== 6) {
      this.errors.icon_color_hex = 'Please select an icon color.';
    }

    if (this.addOn.icon_initials.length > 2) {
      this.errors.icon_initials = 'The icon initials may have at most two characters.';
    }

    if (Object.keys(this.errors).length > 0) {
      this.errorMessage = 'Please correct the errors shown and try again.';
      return;
    }

    if (!this.hasPerLocationTaxRates) {
      this.addOn.tax_rate_per_location = {};
    }

    this.completedCallback(this.addOn);
    this.activeModal.close();
  }

  public taxRateRemoved(taxRateId: number) {
    if (!this.taxRateList) { return true; }

    for (const taxRate of this.taxRateList) {
      if (taxRate.id === taxRateId) { return false; }
    }

    return true;
  }

  public getLocNameById(locId: string) {
    const locations = this.locationService.getLocations();

    if (locations === null) {
      return 'Loading...';
    }

    for (const location of locations) {
      if (location.id.toString() === locId) {
        return location.name;
      }
    }

    return 'Unknown Location';
  }

  public addTaxRateLocation() {
    const modalRef = this.modalService.open(SelectLocationModalComponent);
    modalRef.componentInstance.excludeIds = Object
      .keys(this.addOn.tax_rate_per_location)
      .map(locId => parseInt(locId, 10));
    modalRef.componentInstance.submitCallback = (result: CapitanLocation) => {
      this.addOn.tax_rate_per_location[result.id.toString()] = this.taxRateList[0].id;
    }
  }
}
